const translation: Record<string, string> = {
    // error view
    e0001: "return",
    e0002: "403 Access Denied.",
    e0003: "404 Page Not Found.",
    e0004: "{code} Service is currently unavailable.",

    // base words
    b0000_ko: "한국어",
    b0000_en: "English",

    b0001: "Confirm",
    b0002: "Cancel",
    b0003: "Close",
    b0004: "Upload",
    b0005: "Download",
    b0006: "Delete All",
    b0007: "Delete Selection",
    b0008: "Delete",
    b0009: "Save",
    b0010: "Submit",
    b0011: "Add",
    b0012: "Invalid values exist.",
    b0013: "Ooops! Something went wrong",
    b0014: "No search results found",
    b0015: "Edit",
    b0016: "Success",
    b0017: "Fail",
    b0018: "There's no data",
    b0019: "{version, select, 0 {-} other {v{version}}}",

    // toast words
    t001: "Successfully registered.",
    t002: "Registration failed",
    t003: "Changes saved.",
    t004: "Update failed",
    t005: "Deletion completed",
    t006: "Deletion failed",
    t007: "Please select items to delete",

    // agent sidebar menu name
    m01: "Agent List",
    m02: "Dashboard",
    m03: "Intent",
    m04: "Selector",
    m05: "Entity",
    m06: "Synonym",
    m07: "Typo Correction",
    m08: "Autocomplete",
    m09: "Bulk Test",
    m10: "Deployed",

    m12: "Members",
    m13: "Settings",

    // Component & Layout
    i00001: "View Agent List",
    i00002: "Background Job",
    i00003: "Single Test",
    i00004: "Error occurred during testing",
    i00005: "Enter your Query",
    i00006: "Entity",
    i00007: "Synonym",
    i00008: "Entities",
    i00009: "Skill",
    i00010: "Intent",
    i00011: "View Details",
    i00012: "Response",
    i00013: "Debug",
    i00014: "user said...",
    i00015: "Download Sample",
    i00016_1: "Drop files here or ",
    i00016_2: "select a file",
    i00016_3: ".",
    i00017: "Download and use the sample file for formatting.\n" +
        "Recommended limit: 10,000 rows per upload (no file size limit).\n" +
        "Supported format: Excel (.xlsx) only.",
    i00018: "Delete existing data.",
    i00019: "Only Excel files (.xls, .xlsx) are supported.",
    i00020: "Maximum file size: 20MB",
    i00021: "Failed to upload file. Try again or choose another file.",
    i00022: "Starting upload…",
    i00023: "File upload error.",
    i00024: "{current} in {total}",
    i00025: "pages",
    i00026: "Date",
    i00027: "Background Job",
    i00028: "agent",
    i00029: "intent",
    i00030: "typo",
    i00031: "entity upload",
    i00032: "synonym",
    i00033: "selector",
    i00034: "autocomplete",
    i00035: "bulk test",
    i00036: "training",
    i00037: "Deploy to Production",
    i00038: "entity download",
    i00039: "entity delete",
    i00040: "Bulk Entity Upload",
    i00041: "Deploy Bulk Entities",
    i00042: "In Progress",
    i00043: "Waiting",
    i00044: "Canceled",
    i00045: "Error",
    i00046: "Completed",
    i00047: "Task",
    i00048: "Progress",
    i00049: "Start Time",
    i00050: "Elapsed Time",
    i00051: "Remaining Time",
    i00052: "Processing Time",
    i00053: "Link",
    i00054: "Status",
    i00055: "Privacy Settings",
    i00056: "Change Password",
    i00057: "Language",
    i00058: "Logout",
    i00059: "Admin",
    i00060: "Member",
    i00061: "{job} task completed.",
    i00062: "Process failed due to an error.",
    i00063: "Delete autocomplete",
    i00064: "Please search within {max} days.",
    i00065: "Down",
    i00066: "selected",
    i00067: "Select all",
    i00068: "Deselect",
    i00069: "Move",
    i00070: "Enter search term",
    i00071: "Required field.",
    i00072: "Sorry, I didn't quite get that.",
    i00073: "Please upload a file.",
    i00074: "Cannot select a future date.",
    i00075: "Incorrect format. Use yyyy.mm.dd.",


    // Agent List
    i01001: "Add Agent",
    i01002: "Name",
    i01003: "Please enter agent name",
    i01004: "Language",
    i01005: "Intent Model Settings",
    i01005_o1: "Default",
    i01005_o2: "OpenAI Ada(Experimental)",
    i01006: "Definer Threshold",
    i01007: "Number of Definer Results",

    i01011: "Search by agent name or owner name.",
    i01012: "Active",
    i01013: "Inactive",
    i01014: "There are no active agents.\nClick 'Add Agent' to create one.",
    i01015: "Agent owner",
    i01016: "Inactive Agent",
    i01017: "해당 에이전트는 비활성화된 에이전트입니다. 다시 활성화하시겠습니까?",
    i01018: "The agent name is already in use",
    i01019: "Agent",
    i01020: "Last Updated",
    i01021: "Created At",

    //Dashboard
    i02001: "Provides an overview of the agent's status.",
    i02002: "Agent status",
    i02003: "Intent",
    i02004: "Entity",
    i02005: "Version",
    i02006: "(pcs)",

    i02008: "Intent ranking",
    i02009: "Incoming query count",
    i02010: "Incoming count",
    i02011: "View as a table",
    i02012: "Incoming date",
    i02013: "Skill",
    i02014: "Intent",
    i02015: "Incoming sentence",
    i02016: "There's no data",
    i02017: "Agent statistics",
    i02018: "Log",
    i02019: "Query count",
    i02020: "YYYY-MM-DD",
    i02021: "Score",
    i02022: "Intent",
    i02023: "Training sentence",
    i02024: "Training version",
    i02025: "Live version",
    i02026: "Entity",
    i02027: "Entity value",
    i02028: "No classification",

    //Intent
    i03001: "Manage training sentences required for intent classification.",
    i03002: "Upload intent",
    i03003: "Enter the training data.\ne.g.) I’d like to order a pizza.",
    i03004: "Enter intent name.\ne.g.) order_pizza",
    i03005: "Enter skill name.\ne.g.) order",
    i03006: "Delete all skills and intents",
    i03007: "Delete this skill and intents?\nAll training sentences under the skill and intents will also be deleted.",

    i03009: "Add Skill",
    i03010: "Please enter skill name.",
    i03011: "Edit skill",
    i03012: "Delete skill",
    i03013: "Delete this skill?\nAll intents and training sentences under the skill will also be deleted.",

    i03020: "Skill",
    i03021: "Add Intent",
    i03022: "Please enter intent name.",
    i03023: "Intent settings",
    i03024: "Edit intent name",
    i03025: "Activate Intent / Intent Active",
    i03026: "Intent threshold ({threshold})",
    i03027: "Intent response",
    i03028: "You can create up to five responses per intent. They will be shown randomly.",
    i03029: "Delete intent",
    i03030: "Delete this intent?\nAll training sentences under this intent will also be deleted.",
    i03031: "Slot settings",
    i03032: "File_name, Title, and Description are required mapping columns.",
    i03033: "{intentName} slot",
    i03034: "Delete",
    i03035: "Required",
    i03036: "List",
    i03037: "Parameter",
    i03038: "Enter the parameter",
    i03039: "Entity",
    i03040: "Enter the entity",
    i03041: "Entity value",
    i03042: "Keyword",
    i03043: "Default value",
    i03044: "Enter the default value",
    i03045: "Slot settings guide",
    i03046: "Deliver analysis results to the customer through the slot-filling process.",
    i03047: "Click the intent name to view the training data for that intent.",
    i03048: "Check the characteristics of each data set and configure slots accordingly.",

    i03050: "Training sentence response",
    i03051: "You can create up to five responses per training sentence. They will be shown randomly.",
    i03052: "Delete training sentence",
    i03053: "Delete the training sentence.",
    i03054: "Enter the training sentence.",
    i03055: "Intent",

    i03061: "Expand training sentences",
    i03062: "Collapse training sentences",
    i03063: "Keyword",
    i03064: "Synonym",
    i03065: "Mapping Value",
    i03066: "Nothing",
    i03067: "Move intent",
    i03068: "Select the skill to move to",
    i03069: "Intent",
    i03070: "Training sentence",
    i03071: "Delete all registered intents.",
    i03072: "Enter a sentence",

    //Selector
    i04001: "The intent is assigned only when the input matches a registered training sentence.",
    i04002: "Upload selector",
    i04003: "Enter a sentence to classify as the intent\ne.g.) Let's have pizza.",
    i04004: "Enter the intent name for the text.\ne.g.) order_pizza",
    i04005: "Selector",
    i04006: "Enter a sentence",
    i04007: "Enter a sentence.",
    i04008: "Intent",
    i04009: "Select or enter an intent",
    i04010: "Select or enter an intent",

    i04013: "Delete selected selectors",
    i04014: "Delete the selector",
    i04015: "Search by selector or intent",
    i04016: "Selector",
    i04017: "Intent",
    i04018: "Edit selector",
    i04019: "Delete selector",

    i04022: "Delete the selector",
    i04023: "Delete all registered selectors",

    //Entity
    i05001: "Register and manage dictionaries for intent classification.",
    i05002: "Entity",
    i05003: "Type",

    i05005: "Add Entity",
    i05006: "Entity name",
    i05007: "option",

    i05009: "Enter the entity name.",
    i05012: "Edit entity",
    i05013: "Delete entity",
    i05014: "Delete the entity.",
    i05015: "Enter the entity name.\ne.g.) phone_nm",
    i05016: "Enter a keyword.\ne.g.) phone_nm",
    i05017: "Enter synonyms for the keyword.\ne.g.) phone_nm",
    i05018: "(Optional) Enter a value that will replace the keyword.\ne.g.) code=1",
    i05019: "(Optional) To register as an Ignore Entity, enter 1 or true.",
    i05020: "(Optional) Enter 1 or true to register this as a Post Entity.",
    i05021: "Upload entity",
    i05022: "Delete selected entities",
    i05023: "Delete the entity.",
    i05024: "Entity list",
    i05025: "Search by entity name.",
    i05026: "View entity list",
    i05027: "Keyword",
    i05028: "Enter the keyword",
    i05029: "Mapping value",
    i05030: "Enter the mapping value. (optional)",
    i05031: "Synonym",
    i05032: "Enter the synonym",

    i05034: "Keyword",
    i05035: "Synonym",
    i05036: "Mapping value",
    i05037: "Edit entity value",
    i05038: "Delete entity value",
    i05039: "Delete selected entity values",
    i05040: "Delete the selected entity values?",
    i05041: "Delete entity value",
    i05042: "Delete the entity value",
    i05043: "NORMAL ENTITY is a dictionary used in intent classification.",
    i05044: "POST ENTITY does not affect intent classification and is analyzed only.",
    i05045: "IGNORE ENTITY values are treated as blanks in the user query.",
    i05046: "Please enter the keyword.",
    i05047: "Please add a synonym.",
    i05048: "Delete all registered entities.",
    i05049: "Entity value",
    i05050: "Entity",
    i05051: "Back to list",

    //Synonym
    i06001: "Manage words requiring synonym handling without registering them as entity dictionaries.",
    i06002: "Edit synonyms",
    i06003: "Delete synonyms",
    i06004: "Delete selected synonyms",
    i06005: "Delete synonyms",

    i06007: "Upload synonyms",
    i06008: "Enter the primary keyword.\ne.g.) United Kingdom",
    i06009: "Enter synonyms for the keyword.\ne.g.) UK",
    i06010: "Primary keyword",
    i06011: "Enter the primary keyword.",
    i06012: "Enter the primary keyword.",
    i06013: "Enter the synonym.",
    i06014: "Synonym",
    i06015: "Add synonyms.",
    i06016: "Search using the primary keyword or synonyms.",
    i06017: "Primary keyword",
    i06018: "Delete all registered synonyms.",

    //Typo
    i07001: "Correct typos based on the dictionary.",
    i07002: "Correction keyword",
    i07003: "Typo keyword",
    i07004: "Enter the correction keyword.",
    i07005: "Enter the keyword to be corrected.",
    i07006: "Enter the typo.",
    i07007: "Please add a typo.",
    i07008: "Search by the correction keyword or typo keyword.",
    i07009: "Edit typo correction",
    i07010: "Delete typo correction",
    i07011: "Correction keyword",
    i07012: "Upload typo corrections",
    i07013: "Delete selected typo corrections",
    i07014: "Delete the typo correction.",
    i07016: "Delete the typo correction.",
    i07017: "Enter the keyword to correct the typo.\ne.g.) deep learning",
    i07018: "Enter typos for the keyword.\ne.g.) deeep learning",
    i07019: "Delete all registered typo corrections.",

    //Autocomplete
    i08001: "Manage autocomplete entries for the web chat input field.",
    i08002: "Autocomplete",

    i08004: "Edit autocomplete",
    i08005: "Delete autocomplete",
    i08006: "Add autocomplete",
    i08007: "Enter the autocomplete title.",
    i08008: "Delete selected autocomplete entries",
    i08009: "Delete the autocomplete.",
    i08010: "Edit autocomplete",
    i08011: "Autocomplete name",
    i08012: "Autocomplete token",
    i08013: "The token must be redeployed if modified.",
    i08014: "Delete autocomplete.",
    i08015: "Enter the autocomplete title.",
    i08016: "Enter the autocomplete token.",
    i08017: "Autocomplete title",
    i08018: "Token",
    i08019: "Titles and tokens must be unique across all autocomplete entries.\nChanging a token used in a scenario requires redeployment",

    i08021: "Enter a sentence to use for autocomplete.",
    i08022: "Enter a suggested sentence shown when the user enters a question.\ne.g.) I'd like to order a pizza.",
    i08023: "Upload autocomplete",
    i08024: "Edit autocomplete sentence",
    i08025: "Delete autocomplete sentence",
    i08026: "Delete the autocomplete sentence.",
    i08027: "Delete the selected autocomplete sentences?",
    i08028: "Delete selected autocomplete sentences",
    i08029: "Test autocomplete",
    i08030: "Keyword",
    i08031: "Back to list",
    i08032: "Delete all registered autocomplete sentences.",
    i08033: "Autocomplete sentence",
    i08034: "Autocomplete",

    //Bulk Test
    i09001: "Check intent accuracy through bulk testing.",
    i09002: "Register test",
    i09003: "Test name",
    i09004: "Search by test name.",
    i09005: "Test file name",
    i09006: "Search by test file name.",
    i09007: "Version",
    i09008: "Test date/time",
    i09009: "Result",
    i09010: "Status",
    i09011: "Completed",
    i09012: "In progress",
    i09013: "Cancel",
    i09014: "Failed",
    i09015: "Enter a sentence to test.\ne.g.) I'd like to order a pizza.",
    i09016: "Enter the intent name that the query will be classified into.\ne.g.) Pizza Order",
    i09017: "Enter the skill name for the intent.\ne.g.) Orde",
    i09018: "Accuracy",

    i09020: "Test version:",

    i09023: "Success",
    i09024: "Failed",
    i09025: "Test query",

    i09027: "Question",

    i09029: "Expected intent",
    i09030: "Search by intent name.",
    i09031: "Intent result",
    i09032: "Search by intent name.",
    i09033: "Result",

    i09035: "Success",
    i09036: "Failed",
    i09037: "Score",
    i09038: "Cancel",
    i09039: "Enter the test name.",
    i09040: "File name:",
    i09041: "Tester:",
    i09042: "Date:",
    i09043: "Threshold:",
    i09043_1: "{score} pts",
    i09044: "Back to list",
    i09045: "Bulk tests are run on the training version.",
    i09046: "Delete test",
    i09047: "Delete the test.",
    i09048: "Delete selected tests",
    i09049: "Upload test file",

    //Deployment
    i10001: "Deploy newly trained utterances and entity dictionaries to the service.",
    i10002: "Training",
    i10003: "Deploy",
    i10004: "Deploy guide",

    i10007: "Train with the current data.",
    i10008: "Apply the training version data to the service?",

    i10013: "Type",
    i10014: "Training version",
    i10015: "Deployed version",

    i10027: "Version",
    i10028: "Processed At",
    i10029: "Deployed By",
    i10030: "Agent upload",
    i10031: "Task Description",
    i10032: "In service",
    i10033: "There is no training history.",
    i10034: "Task Details",
    i10035: "Enter the operation details.",
    i10036: "Deployment Time",
    i10037: "Deployed By",
    i10038: "Delete all registered training sentences and entities.",

    //Statistics

    //Member
    i12001: "Manage members who use NLU.",
    i12002: "Add member",

    i12004: "Name",
    i12005: "ID (Email)",
    i12006: "Department",
    i12007: "Type",
    i12008: "Modified Date",
    i12009: "Last login",
    i12010: "Search by email to invite",
    i12011: "Search for a new owner by email",
    i12012: "Chat42 Member Registration Guide",
    i12013: "{username} has been registered as a member.",
    i12014: "Go to agent",
    i12015: "Edit member info",
    i12016: "ID",
    i12017: "Permission",
    i12018: "Delete member",
    i12019: "Deleted members cannot access the agent.",
    i12020: "Edit member",
    i12021: "Search by ID or name.",
    i12022: "Owner",
    i12023: "Member",
    i12024: "Account type",
    i12025: "Enter a valid email address.",
    i12026: "Enter your department.",
    i12027: "Change owner",
    i12028: "Change the agent owner to {username}.",
    i12029: "Add member",
    i12030: "Email",
    i12031: "Name",
    i12032: "Department",
    i12033: "Enter your department.",

    //Setting
    i13001: "Change agent settings.",
    i13002: "Agent name",
    i13003: "Agent token",

    i13005: "System entity settings",
    i13006: "Type",
    i13007: "Use",
    i13008: "Post-processing",
    i13009: "Time",
    i13010: "Date",
    i13011: "Currency",
    i13012: "Unit",
    i13013: "Phone number",
    i13014: "Number",
    i13015: "Quantity",
    i13016: "Agent threshold",
    i13017: "Delete agent",

    i13019: "Recognize HH:MM:SS format",
    i13019_1: "e.g.) 12:30:25 PM, 3:15 PM",
    i13020: "Recognize YYYY-MM-DD format",
    i13020_1: "e.g.) Aug 17, 2022, 2022-08-17",
    i13021: "Recognize KRW (원, ₩) and Korean phonetic numbers as currency.",
    i13021_1: "e.g.) 3000 won, 330,000 won",
    i13022: "Recognize cm, mm, m formats and Korean unit notation.",
    i13022_1: "e.g.) 260mm, 260 millimeters, 2m 30cm",
    i13023: "Recognize standard phone number formats.",
    i13023_1: "e.g.) 010-1234-1234",
    i13024: "Recognize all number formats and Korean phonetic numbers.",
    i13024_1: "e.g.) 123, 3.3 billion",
    i13025: "Recognize stock quantity in 'shares' and 'units'",
    i13025_1: "e.g.) 100 shares, 100 units",
    i13026: "System Entity Info",
    i13027: "Intent Result Limit",

    i13029: "Deleting an agent cannot be undone.\nPlease proceed with caution.\nAre you sure you want to delete it?",

    i13031: "Token copied.",
    i13032: "Refresh agent token",
    i13033: "Regenerate agent token.",
    i13034: "After regenerating, you must update the token on all clients using this agent.",

};

export default translation;

